import { ARTICLECHANGED, TITLECHANGED,FILTERBYSEARCH } from './actionsTypes'

import initialState from '../filtersBlogs/initialState'

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ARTICLECHANGED:
            console.log(action);
            return {
                ...state,
                type: action.payload
            }
        case TITLECHANGED:
            console.log(action);
            return {
                ...state,
                titletxt: action.payload
            }
        case FILTERBYSEARCH:
            console.log(action);
            return {
                ...state,
                searchText: action.payload
            }
        default:
            return state;
    }
}

export default reducer;